
<template>
    <b-container v-resize='onResize' fluid class="bottom-padding no-horiz-padding">

        <div ref='controlsDiv' style='background-color: #ffffff; position: fixed; left: 0; width: 100%; padding-left: 1rem;'>
            <div class='top-padding'>
                <span class='h2'>Draft Color Editor</span>

                <div class='inline-auto-width' style='vertical-align: top; padding-left: 0.5rem'>

                    <file-upload v-if='showUpload && ((isAuthenticated && isSubscriber) || (isEmbed))' style='vertical-align: top' :isImage='false' prompt='Upload WIF' @fileReceived='loadFromWIF'/>
                    <b-button v-if='sampleDraft' variant='outline-secondary' style='vertical-align: top' size='sm' @click='showDownloadDialog(true)'>Download <span class="glyphicon glyphicon-save"></span></b-button>
                    <file-upload v-if='this.sampleDraft' :isImage='true' prompt='Colors from Image' @fileReceived='displayUploadedImage'/>
                    <b-button style='vertical-align: top;' v-if='(tieupHistoryArray && tieupHistoryArray.length > 1)' variant='outline-secondary' size='sm' @click='restoreHistoryState()'>Undo <span class="glyphicon glyphicon-remove"></span></b-button>
                    <b-dropdown style='vertical-align: top;' size='sm' v-if='(!isEmbed)' variant='outline-secondary' left text="Help">
                        <b-dropdown-item to='/draft-editor-instructions'>Instructions</b-dropdown-item>
                        <b-dropdown-item target='_blank' href='https://www.youtube.com/watch?v=EeR1GNLPXjk'>Tutorial Video</b-dropdown-item>
                    </b-dropdown>                    
                </div>
            </div>

            <div style='clear: both; padding-right: 1.0rem; padding-top: 1.0rem;' v-if='(!isEmbed && !isSubscriber)'>
                <subscriber-login-prompt/>
            </div>

            <div style='padding-right: 0.5rem' v-if='this.sampleDraft'>
                <div style='display:inline-block; vertical-align: top; padding: 0; margin: 0'>
                    <div style='display:inline-block; vertical-align: top' v-for='(colNumber, colNumberIndex) in currentColors.length' :key='colNumber'>
                        <div class='inline-auto-width hand-cursor'><color-palette :itemIndex='colNumberIndex' :isSelected = 'colNumberIndex === selectedColorIndex' :initialColor='currentColors[colNumberIndex]' @colorPaletteSelected='onSearchColorPaletteSelected($event)' @colorPaletteDataChanged='onSearchColorPaletteDataChanged($event)' :renderingKey='colorPaletteRenderingKey'/></div><br/>
                    </div>
                </div>

                <div style='vertical-align: top; position: absolute; left: -99999px; padding: 0; margin: 0' ref='palette-div'>
                    <div class='inline-auto-width' v-for='(colNumber, colNumberIndex) in currentColors.length' :key='colNumber' :renderingKey='colorPaletteRenderingKey'>
                        <div :style='{ "background-color": currentColors[colNumberIndex].hex }' class='roundPalette'>
                        </div>
                    </div>
                </div>

                <div style='display: inline-block; vertical-align: center'>
                    <div><span style='visibility:hidden' class="glyphicon glyphicon-pencil"/></div>
                    <b-button size='sm' variant='outline-secondary' @click='addPaletteSlot'><span class="glyphicon glyphicon-plus"></span></b-button>
                </div>
                <div style='display:inline-block; margin-left: 0.2rem; vertical-align: bottom; padding-top: 0.2rem'>
                    <div>
                        <span style='vertical-align: bottom; margin-right: 0.5rem'><input v-model="showLines" name='showLinesCheckbox' class='hand-cursor' type="checkbox" />&nbsp;Lines</span>
                        <span v-if='isOvershotPattern' style='vertical-align: bottom;  margin-right: 0.5rem'><input v-model="showGroundWeaveView" name='showOvershotCheckbox' class='hand-cursor' type="checkbox" />&nbsp;Overshot</span>
                        <span style='vertical-align: bottom; padding-right: 0.5rem;'><input v-model="showReverseSideView" name='showReverseCheckbox' class='hand-cursor' type="checkbox" />&nbsp;Opposite Side</span>
                    </div>
                    <div>
                        Size: <input style='vertical-align: bottom; width: 12rem' type="range" min="1" max="30" step="1" v-model="cellPixelSizeStr">
                    </div>
                </div>

                <div style='margin-top: 0.5rem;' v-if='imageVisible && imageBytes'>
                    <b-button variant='outline-secondary' size='sm' @click='hideImage'>Hide Image</b-button>
                    <span style='margin-left: 0.2rem'>Click on the image to set the selected color.</span>
                </div>

                <div style='margin-top: 0.5rem; margin-bottom: 1rem;' v-if='showSearchAndReplace && (!imageVisible) && (!showGroundWeaveView)'>
                    <b-button variant='outline-secondary' @click='hideReplace'>Done Replacing Colors</b-button>
                    <span style='margin-left: 0.2rem; font-weight: bold' v-if='showSearchAndReplace && (!imageVisible)'>Click on a warp or weft thread color to change all threads of that color to the selected color.</span>
                </div>

                <div style='margin-top: 0.5rem; margin-bottom: 1rem;' v-if='showCopyOrPaste && (!imageVisible) && (!showGroundWeaveView)'>
                    <b-button variant='outline-secondary' @click='hideCopyPaste'>Done Copying and Pasting</b-button>
                    <span style='margin-left: 0.2rem; font-weight: bold' v-if='showCopyColors && (!imageVisible)'>Click and drag across thread colors to copy them.</span>
                    <span style='margin-left: 0.2rem; font-weight: bold' v-if='showPasteColors && (!imageVisible)'>Click on a thread color to paste copied colors.</span>
                </div>

                <div style='margin-top: 0.5rem; margin-bottom: 1rem;' class='small-top-padding' v-if='!showSearchAndReplace && !showCopyOrPaste && (!imageVisible) && (!showGroundWeaveView)'>
                    <b-button variant='outline-secondary' v-if='imageBytes' size='sm' @click='showImage'>Show Image</b-button>
                    <b-button variant='outline-secondary' size='sm' @click='showCopy'>Copy / Paste Colors</b-button>
                    <b-button variant='outline-secondary' size='sm' @click='showReplace'>Replace Colors</b-button>
                    <span style='margin-left: 0.2rem' v-if='(!showSearchAndReplace) && (!showCopyOrPaste) && (!imageVisible)'>Click or drag across thread colors to change to the selected color.</span>                
                </div>
                
            </div>
        </div>
        
        <div :style='draftDivStyle' v-if='!this.sampleDraft'/> <!-- spacer div used when draft not present to push content beneath fixed position controls region by using calculated padding  -->
        
        <div ref='draftDiv' id='draftDiv' :style='draftDivStyle' v-if='this.sampleDraft'> <!-- draftDivStyle will push content beneath fixed position controls region by using calculated padding -->
            <div style='margin-top: 0.5rem; margin-bottom: 1rem;' class='small-top-padding' v-if='!showSearchAndReplace && (imageVisible)'>
                <img id='colorSelectionImage' class='prevent-scrolling-on-touch' ref='displayedImage' style='display: inline-block; max-width: 50%; margin-top:' v-if='imageVisible && imageBytes' :src='imageBytes' @click='imageClicked' @mouseover='onImageMouseOver' @mousemove='onImageMouseMove' @mouseout='onImageMouseOut' @touchstart='onTouchStart' @touchend='onTouchEnd' @touchmove='onTouchMove'/>
            </div>

            <div style='font-size: 0.75rem; margin-top: 0; padding-top:0.2rem; margin-bottom:0; padding-bottom:0.2rem;' v-if='uploadFilename.length > 0'>{{ this.uploadFilename }}</div>

            <div v-if='!showGroundWeaveView'>
                <table class='draftTable' ref='drawdown-table'>
                    <tr>
                        <!-- warp thread colors -->
                        <td :style='getDraftTableCellStyles(this.cellPixelSize, true, true)'><colors-array uniqueCanvasId='warpColorsArray' :rowsCount='1' :columnsCount='sampleDraft.WarpThreadsCount' :itemsCount='sampleDraft.WarpThreadsCount' :cellPixelSize='cellPixelSize' :borderThicknessPixels='borderThicknessPixels' :borderColor='gridBorderColor' :colorsArray='warpThreads' :currentColor='currentRGBColor()' :renderingKey='threadsRenderingKey' :isSearchAndReplace='showSearchAndReplace' :isCopy='showCopyColors' :isPaste='showPasteColors' :copiedColorsArray='copyPasteColorsArray' @colorsCopied='onColorsCopied($event)' :isReadOnly='!allowColorEdits' @colorDataChanged = 'onWarpColorChanged($event)'/></td>
                        <td :style='getDraftTableCellStyles(this.cellPixelSize, false, true)'/>
                        <td :style='getDraftTableCellStyles(this.cellPixelSize, true, true)'/>
                        <td :style='getDraftTableCellStyles(this.cellPixelSize, true, true)'/>
                    </tr>
                    <tr>
                        <td :style='getDraftTableCellStyles(this.cellPixelSize, true, false)'><ruler :itemsCount='sampleDraft.WarpThreadsCount' startingSide='right' :cellPixelSize = 'cellPixelSize' :lineThicknessPixels='borderThicknessPixels' /></td>
                        <td :style='getDraftTableCellStyles(this.cellPixelSize, false, false)'><ruler :itemsCount='sampleDraft.TreadlesCount' startingSide='left' :cellPixelSize = 'cellPixelSize' :lineThicknessPixels='borderThicknessPixels' /></td>
                        <td :style='getDraftTableCellStyles(this.cellPixelSize, true, false)'/>
                        <td :style='getDraftTableCellStyles(this.cellPixelSize, true, false)'/>
                    </tr>
                    <tr>
                        <td :style='getDraftTableCellStyles(this.cellPixelSize, true, true)'>
                            <!-- threading -->
                            <grid uniqueCanvasId='threadingGrid + drawdownRenderingKey' :rowsCount='sampleDraft.ShaftsCount' :columnsCount='sampleDraft.WarpThreadsCount' :cellPixelSize='cellPixelSize' :borderThicknessPixels='borderThicknessPixels' :borderColor='gridBorderColor' cellSelectedColor="#000000" cellNotSelectedColor="#ffffff" :rowMajorArray="threading" :singleColumnSelection='false' :singleRowSelection='true' :isReadOnly='!allowDraftEdits' @gridDataChanged = 'onThreadingCellUpdated($event)' :showInverse='false' :renderingKey='drawdownRenderingKey'/>
                        </td>
                        <td :style='getDraftTableCellStyles(this.cellPixelSize, false, true)'>
                            <!-- tieup -->
                            <grid uniqueCanvasId='tieupGrid + drawdownRenderingKey' :rowsCount='sampleDraft.ShaftsCount' :columnsCount='sampleDraft.TreadlesCount' :cellPixelSize='cellPixelSize'  :borderThicknessPixels='borderThicknessPixels' :borderColor='gridBorderColor' cellSelectedColor="#000000" cellNotSelectedColor="#ffffff" :rowMajorArray="tieup"  :singleColumnSelection='false' :singleRowSelection='false' :isReadOnly='!allowDraftEdits' @gridDataChanged = 'onTieupCellUpdated($event)' :showInverse='showReverseSideView' :renderingKey='drawdownRenderingKey'/>
                        </td>
                        <td :style='getDraftTableCellStyles(this.cellPixelSize, true, true)'><ruler :itemsCount='sampleDraft.ShaftsCount' startingSide='bottom' :cellPixelSize = 'cellPixelSize' :lineThicknessPixels='borderThicknessPixels' /></td>
                        <td :style='getDraftTableCellStyles(this.cellPixelSize, true, true)'/>
                    </tr>
                    <tr>
                        <td :style='getDraftTableCellStyles(this.cellPixelSize, true, true)'>
                            <!-- drawdown -->
                            <drawdown-grid :rowsCount='sampleDraft.WeftThreadsCount' :columnsCount='sampleDraft.WarpThreadsCount' :cellPixelSize='cellPixelSize' :borderThicknessPixels="1" :warpThreads = 'warpThreads' :weftThreads = 'weftThreads' :groundWeaveWeftThreads = '[]' :drawdownArray = 'drawdown' :showDividingLines='showLines' :renderingKey='drawdownRenderingKey + showLines + showReverseSideView' :warpColorTransparency='1.0' :weftColorTransparency='1.0' :groundWeaveDrawdownArray='[]' :showReverseSide='showReverseSideView'/>                        
                        </td>
                        <td :style='getDraftTableCellStyles(this.cellPixelSize, false, true)'>
                            <!-- treadling -->
                            <grid uniqueCanvasId='treadlingGrid + drawdownRenderingKey' :rowsCount='sampleDraft.WeftThreadsCount' :columnsCount='sampleDraft.TreadlesCount' :cellPixelSize='cellPixelSize' :borderThicknessPixels='borderThicknessPixels' :borderColor='gridBorderColor' cellSelectedColor="#000000" cellNotSelectedColor="#ffffff" :rowMajorArray="treadling" :singleColumnSelection='true' :singleRowSelection='false' :isReadOnly='!allowDraftEdits' @gridDataChanged = 'onTreadlingCellUpdated($event)' :showInverse='false' :renderingKey='drawdownRenderingKey'/>
                        </td>
                        <!-- weft thread colors -->
                        <td :style='getDraftTableCellStyles(this.cellPixelSize, true, true)'><ruler :itemsCount='sampleDraft.WeftThreadsCount' startingSide='top' :cellPixelSize = 'cellPixelSize' :lineThicknessPixels='borderThicknessPixels' /></td>
                        <td :style='getDraftTableCellStyles(this.cellPixelSize, true, true)'><colors-array uniqueCanvasId='weftColorsArray' :rowsCount='sampleDraft.WeftThreadsCount' :columnsCount='1' :itemsCount='sampleDraft.WeftThreadsCount' :cellPixelSize='cellPixelSize' :borderThicknessPixels='borderThicknessPixels' :borderColor='gridBorderColor' :colorsArray='weftThreads' :currentColor='currentRGBColor()' :renderingKey='threadsRenderingKey' :isSearchAndReplace='showSearchAndReplace' :isCopy='showCopyColors' :isPaste='showPasteColors'  :copiedColorsArray='copyPasteColorsArray' @colorsCopied='onColorsCopied($event)' :isReadOnly='!allowColorEdits' @colorDataChanged = 'onWeftColorChanged($event)'/></td>
                    </tr>
                    <tr>
                        <td :style='"font-size: " + labelFontSize + "px; line-height: " + labelFontSize * 1.5 + "px;"' colspan='4'>From Handweaving.net {{ fromMessage }}</td>
                    </tr>                  
                </table>
            </div>
            <div v-if='showGroundWeaveView'>
                <table ref='overshot-table'>
                    <tr>
                        <td>
                            <ground-weave-drawdown :shaftsCount='sampleDraft.ShaftsCount' :treadlesCount='sampleDraft.TreadlesCount' :warpThreadsCount='sampleDraft.WarpThreadsCount' :weftThreadsCount='sampleDraft.WeftThreadsCount' :warpThreads='this.warpThreads' :weftThreads='this.weftThreads' :treadling='this.treadling' :threading='this.threading' :tieup='this.tieup' :cellPixelSize='cellPixelSize' :borderThicknessPixels="1" :showDividingLines='showLines' :showReverseSide='showReverseSideView' :renderingKey='drawdownRenderingKey + showLines + showGroundWeaveView + showReverseSideView' :overshotTabbyTreadleNumbers="overshotTabbyTreadleNumbers" />
                        </td>
                    </tr>
                </table>
            </div>
        </div>

        <b-modal ref='downloadModalRef' title='Download Draft' :ok-only='true' ok-title='Cancel' ok-variant='secondary' :no-close-on-backdrop='true' :no-close-on-esc='true' @ok='showDownloadDialog(false)'>
            <div class="d-block text-center">
                Would you like to download the draft, drawdown (in the current size), or colors?
                <br/>
                <br/>
                <b-button class='small-right-padding' @click='downloadAsWIF()' variant='primary'>Download Draft WIF »</b-button>
                <b-button class='small-left-padding' @click='downloadDrawdownAsImage()' variant='primary'>Download Drawdown Image »</b-button>
                <br/>
                <b-button class='small-left-padding' style='margin-top: 1.0rem' @click='downloadColorsAsImage()' variant='primary'>Download Colors Image »</b-button>
            </div>
        </b-modal>
        <b-modal ref='restrictedWIFModalRef' title='Subscription Required' :ok-only='true' ok-title='OK' ok-variant='secondary' :no-close-on-backdrop='true' :no-close-on-esc='true' @ok='showRestrictedWIFDialog(false)'>
            <div class="d-block text-center">
                This draft requires the full version of the Color Editor.  Please see: 
                <br/>
                <br/>
               <span style='font-weight: bold'>https://handweaving.net/draft-editor-introduction</span>
            </div>
        </b-modal>
        <image-pixel-grid v-if='showImagePixelExpansionGrid' :rowsCount = 'imagePixelExpansionGridRows' :columnsCount = 'imagePixelExpansionGridColumns' :cellPixelSize = 'imagePixelExpansionCellPixelSize' :colorsArray = 'imagePixelExpansionColorsArray' :locationX = 'imagePixelExpansionGridX' :locationY = 'imagePixelExpansionGridY' :renderingKey = 'imagePixelExpansionGridRenderingKey' />
        <div ref='sizingDiv' style="height:0;width:0;outline:none;border:none;padding:none;margin:none;box-sizing:content-box;"></div>
    </b-container>
</template>

<script>
import dataService from '../mixins/dataService.js'
import mediaService from '../mixins/mediaService.js'
import urlsService from '../mixins/urlsService.js'
import utilityService from '../mixins/utilityService.js'
import draftEditorService from '../mixins/draftEditorService.js'
import helpUsButton from './HelpUsButton.vue'
import mailChimpSignup from './MailChimpSignup.vue'
import grid from './Grid.vue'
import colorsArray from './ColorsArray.vue'
import drawdownGrid from './DrawdownGrid.vue'
import groundWeaveDrawdown from './GroundWeaveDrawdown.vue'
import colorPalette from './ColorPalette.vue'
import fileUpload from './FileUpload.vue'
import ruler from './Ruler.vue'
import html2canvas from 'html2canvas'
import subscriberLoginPrompt from './SubscriberLoginPrompt.vue'
import imagePixelGrid from './ImagePixelGrid.vue'
import md5 from 'md5'
import resize from 'vue-resize-directive'

export default {
    mixins: [dataService, mediaService, urlsService, utilityService, draftEditorService],
    directives: {
        resize
    },
    data: function() {
        return {
            tieup: null,
            treadling: null,
            threading: null,
            warpThreads: null,
            weftThreads: null,

            tieupHistoryArray: [],
            treadlingHistoryArray: [],
            threadingHistoryArray: [],
            warpThreadsHistoryArray: [],
            weftThreadsHistoryArray: [],

            drawdown: null,
            allWeftThreadNumbers: [],
            allWarpThreadNumbers: [],
            gridBorderColor: '#acacac',
            cellPixelSizeStr: '11',
            borderThicknessPixels: 1,
            colorPaletteRenderingKey: '777',
            drawdownRenderingKey: '777',
            threadsRenderingKey: '777',
            rulersRenderingKey: '777',
            minimumColorsCount: 7,
            currentColors: [],
            selectedColorIndex: 0,
            colorRadioButtonSelections: null,
            sampleDraft: null,
            imageBytes: null,
            imageVisible: false,
            uploadedImage: null,
            showLines: true,
            showSearchAndReplace: false,
            showUpload: true,
            // note: set allowDraftEdits to true later to allow the tieup, treadling, and threading grids to be clicked for editing
            allowDraftEdits: false,
            allowColorEdits: true,
            loadedById: false,
            isEmbed: false,
            showImagePixelExpansionGrid: false,
            imagePixelExpansionGridX: 0,
            imagePixelExpansionGridY: 0,
            imagePixelExpansionGridRows: 11,
            imagePixelExpansionGridColumns: 11,
            imagePixelExpansionCellPixelSize: 0,
            imagePixelExpansionColorsArray: [[]],
            imagePixelExpansionGridRenderingKey: '777',
            lastKnownTouchEvent: null,
            showCopyColors: false,
            showPasteColors: false,
            copyPasteColorsArray: [],
            showGroundWeaveView: false,
            showReverseSideView: false,
            isOvershotPattern: false,
            overshotTabbyTreadleNumbers: [],
            uploadFilename: '',
            controlsDivStyle: '0rem;',
            draftDivStyle: {}
        }
    },
    methods: {
        initializeComponent() {
            this.$store.commit('setPageTitle', 'Weaving Draft Editor')
            this.initializeVariables()
            this.gatherCurrentColors()

            this.tieupHistoryArray = []
            this.treadlingHistoryArray = []
            this.threadingHistoryArray = []
            this.warpThreadsHistoryArray = []
            this.weftThreadsHistoryArray = []

            // load all of the draft's current weft and warp thread numbers
            this.allWeftThreadNumbers = []
            for (let w=0; w < this.sampleDraft.WeftThreadsCount; w++) {
                this.allWeftThreadNumbers.push(w)
            }
            this.allWarpThreadNumbers = []
            for (let w=0; w < this.sampleDraft.WarpThreadsCount; w++) {
                this.allWarpThreadNumbers.push(w)
            }

            // load arrays from draft JSON
            this.tieup = new Array(this.sampleDraft.ShaftsCount)
            this.threading = new Array(this.sampleDraft.ShaftsCount)
            this.treadling = new Array(this.sampleDraft.WeftThreadsCount)
            this.warpThreads = new Array(this.sampleDraft.WarpThreadsCount)
            this.weftThreads = new Array(this.sampleDraft.WeftThreadsCount)
            this.loadArraysFromDraftJSON(this.tieup, this.threading, this.treadling, this.warpThreads, this.weftThreads, this.sampleDraft)

            this.drawdown = this.initializeDrawdownArray(this.sampleDraft.WarpThreadsCount, this.sampleDraft.WeftThreadsCount)

            // determine whether or not the draft is overshot
            this.overshotTabbyTreadleNumbers = this.getOvershotTreadleNumbers(this.tieup, this.treadling)
            this.isOvershotPattern = (this.overshotTabbyTreadleNumbers.length > 0)
            // console.log('overshotTabbyTreadleNumbers: ' + JSON.stringify(this.overshotTabbyTreadleNumbers))

            // causes threads to rerender when the same WIF file is loaded twice and no other parameter for ColorsArray changes to otherwise cause this
            this.threadsRenderingKey = this.uuidv4()

            this.loadDrawdown(this.sampleDraft.ShaftsCount, this.sampleDraft.TreadlesCount, this.sampleDraft.WarpThreadsCount, this.sampleDraft.WeftThreadsCount, this.allWarpThreadNumbers, this.allWeftThreadNumbers, this.drawdown, this.treadling, this.threading, this.tieup, this.showReverseSideView)
            this.drawdownRenderingKey = this.uuidv4()
            this.saveHistoryState()
        },

        initializeVariables() {
            this.treadling=null
            this.threading=null
            // console.log('setting warp and weft threads to null in initializeComponent')
            this.warpThreads=null
            this.weftThreads=null
            this.drawdown=null
            this.allWeftThreadNumbers=[]
            this.allWarpThreadNumbers=[]
            this.gridBorderColor='#acacac'

            this.borderThicknessPixels=1
            this.colorPaletteRenderingKey='777'
            this.drawdownRenderingKey='777'
            this.threadsRenderingKey='777'
            this.minimumColorsCount=7
            this.currentColors=[]
            this.selectedColorIndex=0
            this.colorRadioButtonSelections=null
            if (!this.$route.query.image) {
                this.imageBytes=null
                this.imageVisible = false
                this.uploadedImage=null
            }

            if (!this.$route.query.noupload) {
                this.showUpload=true
            }
            this.showSearchAndReplace=false
            this.showGroundWeaveView=false
            this.showReverseSideView=false
            this.isOvershotPattern=false
            this.overshotTabbyTreadleNumbers = []
            this.uploadFilename = ''
        },

        onThreadingCellUpdated(rowColObj) {
            // let rowIndex = rowColObj.rowIndex
            // let colIndex = rowColObj.colIndex
            this.saveHistoryState()
            this.loadDrawdown(this.sampleDraft.ShaftsCount, this.sampleDraft.TreadlesCount, this.sampleDraft.WarpThreadsCount, this.sampleDraft.WeftThreadsCount, this.allWarpThreadNumbers, this.allWeftThreadNumbers, this.drawdown, this.treadling, this.threading, this.tieup)
            this.drawdownRenderingKey = this.uuidv4()
        },

        onTreadlingCellUpdated(rowColObj) {
            // let rowIndex = rowColObj.rowIndex
            // let colIndex = rowColObj.colIndex
            this.saveHistoryState()
            this.loadDrawdown(this.sampleDraft.ShaftsCount, this.sampleDraft.TreadlesCount, this.sampleDraft.WarpThreadsCount, this.sampleDraft.WeftThreadsCount, this.allWarpThreadNumbers, this.allWeftThreadNumbers, this.drawdown, this.treadling, this.threading, this.tieup)
            this.drawdownRenderingKey = this.uuidv4()
        },

        onTieupCellUpdated(rowColObj) {
            // let rowIndex = rowColObj.rowIndex
            // let colIndex = rowColObj.colIndex
            this.saveHistoryState()
            this.loadDrawdown(this.sampleDraft.ShaftsCount, this.sampleDraft.TreadlesCount, this.sampleDraft.WarpThreadsCount, this.sampleDraft.WeftThreadsCount, this.allWarpThreadNumbers, this.allWeftThreadNumbers, this.drawdown, this.treadling, this.threading, this.tieup)
            this.drawdownRenderingKey = this.uuidv4()
        },

        onWarpColorChanged(threadsIndexObj) {
            // console.log('onWarpColorChanged: ' + JSON.stringify(threadsIndexObj))
            this.saveHistoryState()
            this.drawdownRenderingKey = this.uuidv4()
        },

        onWeftColorChanged(threadsIndexObj) {
            // console.log('onWeftColorChanged: ' + JSON.stringify(threadsIndexObj))
            this.saveHistoryState()
            this.drawdownRenderingKey = this.uuidv4()
        },

        onColorsCopied(copiedColorsObj) {
            // console.log('onColorsCopied: ' + JSON.stringify(copiedColorsObj))
            this.copyPasteColorsArray = copiedColorsObj.copiedColorsArray
            this.drawdownRenderingKey = this.uuidv4()
            this.showCopyColors = false
            this.showPasteColors = true
        },

        onSearchColorPaletteDataChanged(colorDataObj) {
            let index = colorDataObj.itemIndex
            let newColor = colorDataObj.color
            this.currentColors[index].hex = newColor.hex
            this.selectedColorIndex = index
        },

        onSearchColorPaletteSelected(colorDataObj) {
            let index = colorDataObj.itemIndex
            this.selectedColorIndex = index
        },

        loadDraftData() {
            if (this.isAuthenticated && this.$route.params.id) {
                this.loadedById = true
                let draftId = this.$route.params.id
                let isStraightThreading = this.$route.query.sth
                let isStraightTreadling = this.$route.query.str
                let isPointThreading = this.$route.query.pth
                let isPointTreadling = this.$route.query.ptr
                let isTurned = this.$route.query.t

                this.getPatternJson(draftId, isStraightThreading, isStraightTreadling, isPointThreading, isPointTreadling, isTurned, this.authUser.UserID, this.authUser.LoginToken).then(resp => {
                    this.sampleDraft = resp.data
                    // console.log('Draft Data: ' + JSON.stringify(this.sampleDraft))
                    this.$store.commit('setPageTitle', 'Weaving Draft Editor')
                    this.initializeComponent()
                })
            }
        },

        currentRGBColor() {
            return this.hexToRGBColors(this.currentColors[this.selectedColorIndex])
        },

        displayUploadedImage(fileUploadedObj) {
            this.imageBytes = fileUploadedObj.fileContents
            // save here too as an image so we can read pixels later
            this.uploadedImage = new Image()
            this.uploadedImage.src = this.imageBytes
            this.imageVisible = true
            this.showSearchAndReplace = false
        },

        displayUrlImage(srcUrl) {
            // console.log('1')
            this.uploadedImage = new Image()
            this.uploadedImage.crossOrigin = 'anonymous'
            // console.log('2')
            this.uploadedImage.src = srcUrl
            // console.log('3')
            this.imageBytes = srcUrl // has to be non-null to make UI show image
            // console.log('4')
            this.imageVisible = true
            // console.log('5')
            this.showSearchAndReplace = false
            // console.log('6')
        },

        loadFromWIF(fileUploadedObj) {
            let wifText = fileUploadedObj.fileContents
            // console.log('wifText: ' + wifText)
            this.loadedById = false
            this.postWIFToJSON(wifText).then(resp => {
                let treadlingHash = md5(resp.data.Treadling)
                let tieupHash = md5(resp.data.Tieup)
                let threadingHash = md5(resp.data.Threading)
                let hashes = threadingHash + tieupHash + treadlingHash
                let draftHash = md5(hashes)
                let draftToLoad = resp.data
                console.log('draft hash: ' + draftHash)
                if (this.isAuthenticated && this.isSubscriber) { // any draft can be loaded from WIF by subscribers
                    this.sampleDraft = draftToLoad
                    this.initializeComponent()
                    this.uploadFilename = fileUploadedObj.fileName
                }
                else {
                    this.getAllowedDraftHashesJSON().then(resp => { // only drafts included in courses and whitelisted by their hash can be loaded by non-subscribers
                        let allowedDraftHashes = resp.data.allowedDraftHashes
                        if (allowedDraftHashes.includes(draftHash)) {
                            this.sampleDraft = draftToLoad
                            this.initializeComponent()
                            this.uploadFilename = fileUploadedObj.fileName
                        }
                        else {
                            this.showRestrictedWIFDialog(true)
                        }
                    })
                }
            })
        },

        loadFromUrlWIF(url) {
            this.getUrl(url).then(resp => {
                let wifText = resp.data
                this.loadedById = false
                this.postWIFToJSON(wifText, this.authUser.UserID, this.authUser.LoginToken).then(resp => {
                    this.sampleDraft = resp.data
                    this.initializeComponent()
                })
            })
        },

        downloadAsWIF() {
            this.showDownloadDialog(false)
            if (this.sampleDraft) {
                let exportDraft = {}
                exportDraft.ShaftsCount = this.tieup.length // rows count
                exportDraft.TreadlesCount = this.tieup[0].length // columns count
                exportDraft.WarpThreadsCount = this.warpThreads.length
                exportDraft.WeftThreadsCount = this.weftThreads.length
                exportDraft.IsRisingShed = this.sampleDraft.IsRisingShed

                // warp threads
                this.loadDraftJSONFromWarpThreadsArray(this.warpThreads, exportDraft)

                // weft threads
                this.loadDraftJSONFromWeftThreadsArray(this.weftThreads, exportDraft)

                // threading
                this.loadDraftJSONFromThreadingArray(this.threading, exportDraft)

                // treadling
                this.loadDraftJSONFromTreadlingArray(this.treadling, exportDraft)

                // tieup
                this.loadDraftJSONFromTieupArray(this.tieup, exportDraft)

                this.postJSONToWIF(exportDraft).then(resp => {
                    let baseFilename = 'pattern'
                    if (this.uploadFilename.length > 0) {
                        baseFilename = this.uploadFilename
                    }
                    else if (this.$route.params.id) {
                        baseFilename = this.$route.params.id
                    }
                    if (!baseFilename.toLowerCase().endsWith('.wif')) {
                        baseFilename += '.wif'
                    }
                    let wifData = resp.data
                    var wifFile = new Blob([wifData], { type: 'application/weaving-information-format' })
                    this.saveAs(wifFile, baseFilename)
                })
            }
        },

        downloadDrawdownAsImage() {
            this.showDownloadDialog(false)
            let htmlElementName = this.showGroundWeaveView ? 'overshot-table' : 'drawdown-table'
            this.downloadAsImage(htmlElementName)
        },

        downloadColorsAsImage() {
            this.showDownloadDialog(false)
            let htmlElementName = 'palette-div'
            this.downloadAsImage(htmlElementName)
        },

        downloadAsImage(htmlElementName) {
            html2canvas(this.$refs[htmlElementName])
            .then(canvas => {
                // console.log('canvas: ', canvas)
                canvas.toBlob(blob => {
                    // console.log('blob: ', blob)
                    let baseFilename = 'pattern'
                    if (this.uploadFilename.length > 0) {
                        baseFilename = this.uploadFilename
                    }
                    else if (this.$route.params.id) {
                        baseFilename = this.$route.params.id
                        if (htmlElementName.startsWith('palette')) {
                            baseFilename += '-colors'
                        }
                    }
                    if (baseFilename.endsWith('.wif')) {
                        baseFilename = baseFilename.substr(0, baseFilename.lastIndexOf('.wif'))
                    }
                    baseFilename += '.png'
                    this.saveAs(blob, baseFilename)
                }, 'image/png')
            }).catch((error) => {
                console.log('Error saving drawdown image', error)
            })
        },

        showDownloadDialog(isVisible) {
            isVisible? this.$refs.downloadModalRef.show() : this.$refs.downloadModalRef.hide()
        },

        showRestrictedWIFDialog(isVisible) {
            isVisible? this.$refs.restrictedWIFModalRef.show() : this.$refs.restrictedWIFModalRef.hide()
        },

        saveAs(fileData, fileName) {
            let url = window.URL || window.webkitURL
            let link = url.createObjectURL(fileData)
            let a = document.createElement('a')
            a.download = fileName
            a.href = link
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
        },

        readColorFromImage(x, y) {
            let canvas = document.createElement('canvas')
            let displayedImage = this.$refs['displayedImage']
            canvas.width = displayedImage.width
            canvas.height = displayedImage.height
            let context = canvas.getContext('2d')
            context.drawImage(this.uploadedImage, 0, 0, this.uploadedImage.width, this.uploadedImage.height,     // source rectangle
                   0, 0, canvas.width, canvas.height) // destination rectangle
            let colorValue = context.getImageData(x, y, 1, 1).data
            let R = colorValue[0]
            let G = colorValue[1]
            let B = colorValue[2]
            let hexColor = this.RGBToHex(R, G, B)
            this.currentColors[this.selectedColorIndex] = { 'hex': hexColor }
            this.colorPaletteRenderingKey = this.uuidv4()
        },

        readColorGridFromImage(centerX, centerY, gridWidth, gridHeight) {
            // gridWidth and gridHeight must be odd numbers for the center point in this method to work correctly
            let canvas = document.createElement('canvas')
            let displayedImage = this.$refs['displayedImage']
            canvas.width = displayedImage.width
            canvas.height = displayedImage.height
            let context = canvas.getContext('2d')

            let upperLeftX = centerX - Math.floor(gridWidth / 2)
            let upperLeftY = centerY - Math.floor(gridHeight / 2)

            context.drawImage(this.uploadedImage, 0, 0, this.uploadedImage.width, this.uploadedImage.height,     // source rectangle
                   0, 0, canvas.width, canvas.height) // destination rectangle
            let colorValues = context.getImageData(upperLeftX, upperLeftY, gridWidth, gridHeight).data
            let colorGridArray = []
            for (let row = 0; row < gridHeight; row++) {
                let rowColumnsArray = []
                let rowIndex = gridWidth * row * 4 // four entries for each item (RGBA)
                for (let col=0; col < gridWidth; col++) {
                    let colorObj = {}
                    let colIndex = col * 4
                    let colorIndex = rowIndex + colIndex
                    colorObj.R = colorValues[colorIndex]
                    colorObj.G = colorValues[colorIndex + 1]
                    colorObj.B = colorValues[colorIndex + 2]
                    rowColumnsArray.push(colorObj)
                }
                colorGridArray.push(rowColumnsArray)
            }
            // console.log('colorGridArray: ' + JSON.stringify(colorGridArray))
            return colorGridArray
        },

        imageClicked(e) {
            let rect = e.target.getBoundingClientRect()
            let x = Math.floor(e.clientX - rect.left)
            let y = Math.floor(e.clientY - rect.top)
            this.readColorFromImage(x, y)
        },

        hideImage() {
            this.imageVisible = false
        },

        showImage() {
            this.imageVisible = true
        },

        onImageMouseOver(e) {
            // console.log('in imageMouseOver')

            if (this.imagePixelExpansionCellPixelSize === 0) {
                this.imagePixelExpansionCellPixelSize = this.getRemPixels()
            }

            this.showImagePixelExpansionGrid = true
            this.refreshPixelGrid(e)
        },

        onImageMouseMove(e) {
            if (this.imagePixelExpansionCellPixelSize === 0) {
                this.imagePixelExpansionCellPixelSize = this.getRemPixels()
            }
            // console.log('in imageMouseMove')
            // console.log('clientX: ' + e.clientX + ', clientY: ' + e.clientY)
            this.refreshPixelGrid(e)
        },

        onImageMouseOut(e) {
            // console.log('in imageMouseOut')
            this.showImagePixelExpansionGrid = false
        },

        onTouchStart(e) {
            var touch = e.touches[0]
            this.lastKnownTouchEvent = touch
            var mouseEvent = new MouseEvent('mouseover', { clientX: touch.clientX, clientY: touch.clientY })
            let img = this.$refs['displayedImage']
            img.dispatchEvent(mouseEvent)
        },

        onTouchEnd(e) {
            // console.log('in onTouchEnd, e: ' + JSON.stringify(e))
            let img = this.$refs['displayedImage']
            let touch = this.lastKnownTouchEvent
            let mouseEvent = new MouseEvent('click', { clientX: touch.clientX, clientY: touch.clientY })
            img.dispatchEvent(mouseEvent)
            mouseEvent = new MouseEvent('mouseout', { clientX: touch.clientX, clientY: touch.clientY })
            img.dispatchEvent(mouseEvent)
        },

        onTouchMove(e) {
            var touch = e.touches[0]
            this.lastKnownTouchEvent = touch
            var mouseEvent = new MouseEvent('mousemove', { clientX: touch.clientX, clientY: touch.clientY, buttons: 1 })
            let img = this.$refs['displayedImage']
            img.dispatchEvent(mouseEvent)
        },

        refreshPixelGrid(e) {
            let offsetAmount = this.imagePixelExpansionCellPixelSize * 3
            this.imagePixelExpansionGridX = e.clientX + window.scrollX + offsetAmount
            this.imagePixelExpansionGridY = e.clientY + window.scrollY - offsetAmount
            this.loadGridColorsArray(e)
        },

        loadGridColorsArray(e) {
            let rect = e.target.getBoundingClientRect()
            let x = Math.floor(e.clientX - rect.left)
            let y = Math.floor(e.clientY - rect.top)
            this.imagePixelExpansionColorsArray = this.readColorGridFromImage(x, y, this.imagePixelExpansionGridColumns, this.imagePixelExpansionGridRows)
            this.imagePixelExpansionGridRenderingKey = this.uuidv4()
        },

        gatherCurrentColors() {
            let colorsFound = []

            let urlColorFound = true
            let i=1
            while (urlColorFound) {
                let querykey = 'c' + i
                if (this.$route.query[querykey]) {
                    let colorHexStr = '#' + this.$route.query[querykey]
                    // console.log('colorHexStr: ' + colorHexStr)
                    colorsFound.push(colorHexStr)
                    i++
                }
                else {
                    urlColorFound = false
                }
            }

            for (let threadNumber=0; threadNumber < this.sampleDraft.WarpThreadsCount; threadNumber++) {
                let thread = this.sampleDraft.WarpThreads[threadNumber]
                let threadHexColor = this.RGBToHex(thread.R, thread.G, thread.B)
                if (!colorsFound.includes(threadHexColor)) {
                    colorsFound.push(threadHexColor)
                }
            }

            for (let threadNumber=0; threadNumber < this.sampleDraft.WeftThreadsCount; threadNumber++) {
                let thread = this.sampleDraft.WeftThreads[threadNumber]
                let threadHexColor = this.RGBToHex(thread.R, thread.G, thread.B)
                if (!colorsFound.includes(threadHexColor)) {
                    colorsFound.push(threadHexColor)
                }
            }

            this.currentColors = []
            for (let color of colorsFound) {
                this.currentColors.push({ 'hex': color })
            }

            // add some empty slots
            this.currentColors.push({ 'hex': '#ffffff' })
            this.currentColors.push({ 'hex': '#ffffff' })

            // make sure the palette is at least a certain length
            while (this.currentColors.length < this.minimumColorsCount) {
                this.addPaletteSlot()
            }
            this.colorPaletteRenderingKey = this.uuidv4()
        },

        addPaletteSlot() {
            this.currentColors.push({ 'hex': '#ffffff' })
        },

        hideReplace() {
            this.showSearchAndReplace = false
        },

        showReplace() {
            this.showSearchAndReplace = true
        },
        hideCopyPaste() {
            this.showCopyColors = false
            this.showPasteColors = false
        },
        showCopy() {
            this.showCopyColors = true
        },
        showPaste() {
            this.showPasteColors = true
        },
        saveHistoryState() {
            this.tieupHistoryArray.push(this.deepCopyGridArray(this.tieup))
            this.treadlingHistoryArray.push(this.deepCopyGridArray(this.treadling))
            this.threadingHistoryArray.push(this.deepCopyGridArray(this.threading))
            this.warpThreadsHistoryArray.push(this.deepCopyColorsArray(this.warpThreads))
            this.weftThreadsHistoryArray.push(this.deepCopyColorsArray(this.weftThreads))
        },
        restoreHistoryState() {
            console.log('in restoreHistoryState, length tieup before=' + this.tieupHistoryArray.length + ' length warp before = ' + this.warpThreadsHistoryArray.length)
            if (this.tieupHistoryArray.length > 1) {
                this.tieupHistoryArray.pop()
                this.tieup = this.deepCopyGridArray(this.tieupHistoryArray[this.tieupHistoryArray.length-1])

                this.treadlingHistoryArray.pop()
                this.treadling = this.deepCopyGridArray(this.treadlingHistoryArray[this.treadlingHistoryArray.length-1])

                this.threadingHistoryArray.pop()
                this.threading = this.deepCopyGridArray(this.threadingHistoryArray[this.threadingHistoryArray.length-1])

                this.warpThreadsHistoryArray.pop()
                this.warpThreads = this.deepCopyColorsArray(this.warpThreadsHistoryArray[this.warpThreadsHistoryArray.length-1])

                this.weftThreadsHistoryArray.pop()
                this.weftThreads = this.deepCopyColorsArray(this.weftThreadsHistoryArray[this.weftThreadsHistoryArray.length-1])

                this.threadsRenderingKey = this.uuidv4()
                this.drawdownRenderingKey = this.uuidv4()
            }
            console.log('in restoreHistoryState, length tieup after=' + this.tieupHistoryArray.length + ' length warp after = ' + this.warpThreadsHistoryArray.length)
        },

        onResize() {
            console.log('in onResize')
            let controlsDiv = this.$refs.controlsDiv
            let controlsDivHeight = controlsDiv.offsetHeight
            this.draftDivStyle = { paddingTop: controlsDivHeight + 'px' }
        },

        doKeyboardCommand(e) {
            let cmd = String.fromCharCode(e.keyCode).toLowerCase()
            if (cmd === 'z') {
                this.restoreHistoryState()
            }
        }
    },
    components: {
        imagePixelGrid: imagePixelGrid,
        helpUsButton: helpUsButton,
        mailChimpSignup: mailChimpSignup,
        grid: grid,
        colorsArray: colorsArray,
        drawdownGrid: drawdownGrid,
        groundWeaveDrawdown: groundWeaveDrawdown,
        colorPalette: colorPalette,
        fileUpload: fileUpload,
        ruler: ruler,
        html2canvas: html2canvas,
        subscriberLoginPrompt: subscriberLoginPrompt
    },

    watch: {
        '$route.params.id': function() {
            this.loadDraftData()
        },
        'authUser': function() {
            this.loadDraftData()
        }
    },
    computed: {
        isSubscriber: function() {
            return this.$store.getters.isSubscriber
        },
        authUser: function() {
            return this.$store.state.authUser
        },
        isAuthenticated: function() {
            let val=this.$store.getters.isAuthenticated
            // console.log('in isAuthenticated, returning ' + JSON.stringify(val))
            return val
        },
        currentOrientation: function() {
            if (this.$store.getters.isSubscriber) {
                if (!this.orientationInitialized) {
                    this.orientation = this.$store.state.authUserSettings.Orientation
                    this.orientationInitialized = true
                }
            }
            return this.orientation
        },
        tableCellWidthHeight: function() {
            return 'width: ' + this.cellPixelSize + this.borderThicknessPixels + 'px; ' + 'height: ' + this.cellPixelSize + this.borderThicknessPixels + 'px;'
        },
        cellPixelSize: function() {
            return parseInt(this.cellPixelSizeStr)
        },
        fromMessage: function() {
            if (this.loadedById) {
                return '#' + this.$route.params.id
            }
        },
        labelFontSize: function() {
            let size = this.cellPixelSize * 1.5
            return size
        },
        showCopyOrPaste: function() {
            return this.showCopyColors || this.showPasteColors
        }
    },
    created() {
        window.addEventListener('keydown', this.doKeyboardCommand)
        this.loadDraftData()
        this.$store.commit('setPageTitle', 'Weaving Drafts Archive')
        if (this.$route.query.embed) {
            this.$store.commit('setShowHeaderFooter', false)
            this.isEmbed = true
        }
        if (this.$route.query.image) {
            this.displayUrlImage(this.$route.query.image)
        }
        if (this.$route.query.nolines) {
            this.showLines = false
        }
        if (this.$route.query.noupload) {
            this.showUpload = false
        }
        if (this.$route.query.file) {
            this.loadFromUrlWIF(this.$route.query.file)
        }
        if (this.$route.query.readonly) {
            this.allowDraftEdits = false
        }
        if (this.$route.query.colorreadonly) {
            this.allowColorEdits = false
        }
        if (this.$route.query.size) {
            this.cellPixelSizeStr = this.$route.query.size
        }
    },
    destroyed() {
        window.removeEventListener('keydown', this.doKeyboardCommand)
    }
}
</script>

<style scoped>

.roundPalette {
    display: inline-block;
    width: 7rem;
    height: 7rem;
    border-radius: 50%;
    border: solid black 1px;
}

</style>



// WEBPACK FOOTER //
// src/components/DraftEditor.vue